import { AlertTitle } from '@chakra-ui/react';
import { Alert, AlertIcon, AlertDescription } from '@/components/v4';

/*
 * component to display a error message if it exists
 * else display a generic error
 */
const Error = (props) => {
    const { error, style } = props;

    return (
        <Alert status="error" style={style}>
            <AlertIcon />
            <AlertTitle>
                {error?.name || error?.response?.status || 'Error'}
            </AlertTitle>
            <AlertDescription>
                {error?.response?.data?.message || error?.message || (
                    <>
                        Sorry we are having difficulties processing your request
                        at this time. <br />
                        Please try again later. <br />
                        If the problem persists please contact your
                        administrator.
                    </>
                )}
            </AlertDescription>
        </Alert>
    );
};

export default Error;
